export interface ILocation {
  coordinates: [number, number];
  name: string;
}

export enum ERoutingMode {
  Auto = 'auto',
  Masstransit = 'masstransit',
  Pedestrian = 'pedestrian',
}

export enum ERouteStatus {
  Initial = 'Initial',
  Loading = 'Loading',
  Succeed = 'Succeed',
  Failed = 'Failed',
}

export interface IRouteInfo {
  distance: string;
  routingTime: string;
}

export interface IRoute extends IRouteInfo {
  from: ILocation | null;
  to: ILocation | null;
  mode: ERoutingMode;
  status: ERouteStatus;
}

export interface IPathProps {
  text: string;
  value: number;
}
